module.exports = __webpack_public_path__ + "static/media/house10lg.53d9444c.png";